// extracted by mini-css-extract-plugin
export default {"spinner":"jFvcDBVv0PfANZVogGle","animated":"HS5hTSTh3fheDaPSEMCL","animation-scale-spin":"zkj1KQHJM9ZtkfwLDPcC"};